// blueprint.js: the single source of the mock-exam composition (PLAN §5.2): per section the
// question total and the allowed CALC band [lo, hi]. GEN = total - CALC. Read by exam
// assembly and by build-registry's coverage report.

export const BLUEPRINT = {
  'air-law': { total: 20, calc: [4, 6] },
  navigation: { total: 20, calc: [13, 16] },
  meteorology: { total: 30, calc: [8, 10] },
  aeronautics: { total: 30, calc: [8, 10] },
};
